import { ref } from 'vue'
import moment, { type Moment } from 'moment'

// Plain refs synced from Vuex in store/index.js, since importing the Vuex store here would form a
// cycle through the job components.
// Features:FieldViewDateWindow (IA-586 rollout; delete once promoted); null until the flags load.
export const dateWindowFlag = ref<boolean | null>(null)
// Settings:MaxMapDateRangeDays, in calendar dates; null until the organization config loads.
export const mapMaxDateRangeDays = ref<number | null>(null)

// The rolling default: a week back through tomorrow, recomputed each day it's used. Without the
// FieldViewDateWindow flag it is the old window, a week back through today.
// A cap shorter than that keeps the end and starts later, so the default never needs trimming.
export function defaultDateRange(throughTomorrow = true, maxDays: number | null = null) {
  const start = moment().startOf('day').subtract(7, 'days')
  const end = (throughTomorrow ? moment().add(1, 'day') : moment()).endOf('day')
  return (maxDays !== null && normalizeMapDateRange(start, end, maxDays)) || { start, end }
}

// Returns null when there is no usable range, so the caller falls back to the rolling default.
export function normalizeMapDateRange(start: Moment | null, end: Moment | null, maxDays: number) {
  if (
    !start?.isValid() ||
    !end?.isValid() ||
    end.isBefore(start) ||
    end.format('YYYY-MM-DD') < start.format('YYYY-MM-DD')
  ) {
    return null
  }

  const selectedDays = end.clone().startOf('day').diff(start.clone().startOf('day'), 'days') + 1
  if (selectedDays > maxDays) {
    return {
      start: end
        .clone()
        .subtract(maxDays - 1, 'days')
        .startOf('day'),
      end: end.clone().endOf('day'),
    }
  }

  return { start, end }
}
